import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const TicketList = lazy(() => import('../../container/ticket/TicketList'));

function TicketRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={TicketList} />
    </Switch>
  );
}

export default TicketRoutes;
